var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.607 0.816853C13.2073 1.76084 12.1983 3.29074 11.9053 4.95085C11.6123 6.54586 12.1657 6.77372 14.1513 5.92739C15.8765 5.14616 17.2437 3.29074 17.5041 1.33767C17.6669 0.035624 17.6669 0.00307274 16.7554 0.00307274C16.2346 0.00307274 15.2581 0.361136 14.607 0.816853Z",
    fill: "#1C1C27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0689 7.06707C2.3346 8.49932 1 10.9732 1 14.684C1 18.8506 2.85542 23.4078 5.58972 25.8491C6.82666 26.9884 7.05452 27.0535 8.45422 26.9233C9.268 26.8256 10.5701 26.5652 11.3513 26.3374C12.5557 25.9468 12.9463 25.9793 14.3134 26.4676C16.2991 27.1512 18.0243 27.1837 19.0659 26.5001C20.0424 25.8491 22.2885 22.5614 22.8093 21.0315C23.1674 19.9248 23.1348 19.8597 21.7026 18.5251C19.0659 16.1163 18.9357 12.8937 21.4096 10.3547L22.614 9.1178L21.8002 8.27147C20.1727 6.48115 17.3732 6.02543 14.1181 7.06707C12.4906 7.58789 12.2953 7.58789 10.6677 7.06707C8.48677 6.3835 6.3384 6.3835 5.0689 7.06707Z",
    fill: "#1C1C27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.ece2ef0aaf3f36aefb43d174c97d6925.svg";
export { ForwardRef as ReactComponent };